<template>
  <div class="table-wrapper" v-if="tBodyData.length > 0">
    <p class="table-title">
      <span class="hbtitle">
        <i />
        期末投资组合平均剩余期限分布
      </span>
    </p>

    <div class="thead">
      <div v-for="(hItem,hIndex) in tHeadData" :key="hIndex">
        <span class="hItem-text">{{hItem}}</span>
      </div>
    </div>

    <div>
      <div v-for="(bItem,bIndex) in tBodyData" :key="bIndex" class="bItem">
        <div>
          <span class="bItem-name">{{bItem.name}}</span>
        </div>
        <div>
          <span class="bItem-proportion">{{bItem.v1}}</span>
        </div>
        <div>
          <span class="bItem-previous">{{bItem.v2}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {
  detailPushPage,
} from '@/utils/nativeBridge';
import StoreManger from '@/utils/FundHQJHManger';

export default {
  name: 'FundTablePositionszj',
  components: {},
  data() {
    return {
      precent: 0,
      fundCode: '',
      nativeData: {},
      holddate: '',
      dataCc: {},
      tHeadData: ['平均剩余期限', '资产占比', '负债占比'],
      tBodyData: [],
    };
  },
  mounted() {
  },
  methods: {
    clickMore() {
      const baseInfo = StoreManger.getFundJJXQ();
      const name = StoreManger.getFundJJXQNAME(baseInfo);
      const code = StoreManger.getFundJJXQCODE(baseInfo);

      detailPushPage({
        appId: 'b34ccfc4ed9a4af4a4880fee485cf417',
        url: '/pages/Index',
        params: {
          fundCode: code,
          fundName: name,
          index: '1',
        },
      });
    },
    async render(iscache) {
      this.nativeData = this.$store.state.native.fund;
      this.fundCode = this.nativeData.fundCode;
      this.loadData(iscache);
      this.holddate = StoreManger.getFundJJCCExpansion();
    },
    async loadData() {
      const hbdata = StoreManger.getFundHBCC();
      if (hbdata) {
        this.dataCc = hbdata.Datas;
      }
      if (!this.dataCc) {
        return;
      }
      const datas = this.configholdhbData(this.dataCc.FundMMDistribute);
      if (this.dataCc.FundMMDistribute) {
        if (this.dataCc.FundMMDistribute.SHOWTYPE === '1') {
          this.tBodyData = datas.list90120;
        } else {
          this.tBodyData = datas.list90180;
        }
      }
    },
    configholdhbData(data) {
      const list90180 = [
        {
          name: '30天以内',
          v1: `${this.getPerValue(data, 'APCTNC30')}`,
          v2: `${this.getPerValue(data, 'BPCTNV33')}`,
        },
        {
          name: '30天(含)-60天',
          v1: `${this.getPerValue(data, 'T60APCTNV30')}`,
          v2: `${this.getPerValue(data, 'T60DPCTNV30')}`,
        },
        {
          name: '60天(含)-90天',
          v1: `${this.getPerValue(data, 'T90APCTNV60')}`,
          v2: `${this.getPerValue(data, 'T90DPCTNV60')}`,
        },
        {
          name: '90天(含)-180天',
          v1: `${this.getPerValue(data, 'T180APCTNV90')}`,
          v2: `${this.getPerValue(data, 'T180DPCTNV90')}`,
        },
        {
          name: '180天(含)-397天',
          v1: `${this.getPerValue(data, 'T397APCTNV180')}`,
          v2: `${this.getPerValue(data, 'T397DPCTNV180')}`,
        },
        {
          name: '总计',
          v1: `${this.getPerValue(data, 'ASSETPCTNV')}`,
          v2: `${this.getPerValue(data, 'DEPOSITPCTNV')}`,
        }];
      const list90120 = [
        {
          name: '30天以内',
          v1: `${this.getPerValue(data, 'APCTNC30')}`,
          v2: `${this.getPerValue(data, 'BPCTNV33')}`,
        },
        {
          name: '30天(含)-60天',
          v1: `${this.getPerValue(data, 'T60APCTNV30')}`,
          v2: `${this.getPerValue(data, 'T60DPCTNV30')}`,
        },
        {
          name: '60天(含)-90天',
          v1: `${this.getPerValue(data, 'T90APCTNV60')}`,
          v2: `${this.getPerValue(data, 'T90DPCTNV60')}`,
        },
        {
          name: '90天(含)-120天',
          v1: `${this.getPerValue(data, 'T120APCTNV90')}`,
          v2: `${this.getPerValue(data, 'T120DPCTNV90')}`,
        },
        {
          name: '120天(含)-397天',
          v1: `${this.getPerValue(data, 'T397APCTNV120')}`,
          v2: `${this.getPerValue(data, 'T397DPCTNV120')}`,
        },
        {
          name: '总计',
          v1: `${this.getPerValue(data, 'ASSETPCTNV')}`,
          v2: `${this.getPerValue(data, 'DEPOSITPCTNV')}`,
        }];
      return { list90180, list90120, data };
    },
    getPerValue(data, key) {
      if (!data) {
        return '--';
      }
      if (data[key] === '--' || !data[key]) {
        return data[key];
      }
      return `${parseFloat(data[key]).toFixed(2)}%`;
    },
  },
};
</script>

<style scoped lang="less">
.table-wrapper {
  padding: 0 24px;
  padding-bottom: 10px;
}
.gray {
  color: @app-color-stay;
}
.red {
  color: @app-color-up;
}
.green {
  color: @app-color-down;
}
.table-title {
  font-family: PingFangSC-Regular;
  font-size: 30px;
  color: #000000;
  line-height: 84px;
  height: 84px;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  i {
    width: 10px;
    height: 10px;
    background-color: #73B5FF;
    margin-right: 10px;
    display: inline-block;
    border-radius: 50%;
    position: relative;
  }
}

.thead {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  > div {
    display: flex;
    text-align: center;
    width: 20%;
    &:nth-child(1) {
      width: 40%;
      text-align: left;
    }
    &:nth-last-child(1) {
      width: 20%;
      text-align: right;
      align-items: flex-end;
    }
  }
}

.hItem-text {
  height: 40px;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #999999;
  line-height: 40px;
  width: 100%;
}

.bItem {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 30px 0;
  > div {
    width: 20%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &:nth-child(1) {
      width: 40%;
      align-items: flex-start;
    }
    &:nth-last-child(1) {
      width: 20%;
      align-items: flex-end;
    }
  }
  &-name {
    font-family: PingFangSC-Regular;
    font-size: 30px;
    color: #000000;
    line-height: 30px;
  }
  &-code {
    font-family: DINAlternate-Bold;
    font-size: 24px;
    color: #666666;
    text-align: right;
    line-height: 24px;
  }
  &-price {
    font-family: DINAlternate-Bold;
    font-size: 32px;
    text-align: center;
    line-height: 30px;
    margin-bottom: 10px;
  }
  &-priceRatio {
    font-family: DINAlternate-Bold;
    font-size: 24px;
    text-align: center;
    line-height: 24px;
  }
  &-proportion {
    font-family: DINAlternate-Bold;
    font-size: 32px;
    color: #000000;
    text-align: center;
    line-height: 30px;
  }
  &-previous {
    font-family: DINAlternate-Bold;
    font-size: 32px;
    color: #000000;
    text-align: right;
    line-height: 30px;
  }
}
.hbtitle{
  align-items: center;
  display: flex;
}
.right-arrow {
  margin-left: 5px;
  width: 32px;
  height: 32px;
}
</style>
